import React from "react";
import { DateRange } from 'react-date-range';
import classes from './calender.module.scss'
const PopupCalander = (props: any) => {
    const { setToggleHover, setSelectionRange, data, change, selectionRange } = props;
    const handleSelect = (ranges: any) => {


        // // totalDaysSelected, setTotalDaysSelected
        setSelectionRange({
            startDate: new Date(ranges.range1.startDate),
            endDate: new Date(ranges.range1.startDate)
        });
        let updateData = [...data];

        updateData.forEach((node) => {
            if (node.name === 'startDate') {
                node.value = new Date(ranges.range1.startDate);


            }
            if (node.name === 'endDate') {
                node.value = new Date(ranges.range1.startDate);
            }
        })

        change([...updateData])

        return true;
    }

    return <div onClick={(e) => e.stopPropagation()} className={classes.PopUpElement}>
        {/* <div onClick={() => setToggleHover(false)} className={classes.popUpBG}> */}
        <div className={classes.PopUpElementComp}>
            <DateRange
                // minDate={endDate}
                ranges={[selectionRange]}
                onChange={handleSelect}
                showDateDisplay={true}
                months={2}
                showMonthAndYearPickers={false}
                direction="horizontal" />
            <div style={{ height: "51px" }}>
                <span onClick={() => setToggleHover(false)} className="NextButton okButton">Apply</span>
            </div>
        </div>
        {/* </div> */}

    </div>
}
export default PopupCalander